import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "select", "submit", "formContent"]
  static values = {
    allDisabled: Boolean
  }

  connect() {
    if (this.allDisabledValue) {
      this.formContentTarget.classList.add("hidden")
      this.selectTarget.disabled = true
      this.submitTarget.disabled = true
    } else {
      this.toggle({ target: { value: this.selectTarget.value } })
    }
  }

  toggle(event) {
    const selectedType = event.target.value
    const selectedOption = this.selectTarget.querySelector(`option[value="${selectedType}"]`)

    if (selectedOption.disabled) {
      this.formContentTarget.classList.add("hidden")
      this.submitTarget.disabled = true
      return
    }

    this.formContentTarget.classList.remove("hidden")
    this.submitTarget.disabled = false

    this.contentTargets.forEach(content => {
      if (content.dataset.type === selectedType) {
        content.classList.remove("hidden")
        // Enable required fields in the visible section
        content.querySelectorAll('select, input, textarea').forEach(field => {
          field.disabled = false
        })
      } else {
        content.classList.add("hidden")
        // Disable required fields in hidden sections
        content.querySelectorAll('select, input, textarea').forEach(field => {
          field.disabled = true
        })
      }
    })
  }
}
